import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=50da6aeb&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=50da6aeb&prod&lang=css&"
import style1 from "./admin.vue?vue&type=style&index=1&id=50da6aeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da6aeb",
  null
  
)

export default component.exports